// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-474d8ba7] .p-tabmenu .p-tabmenu-nav .p-tabmenuitem .p-menuitem-link:not(.p-disabled):focus{box-shadow:none}[data-v-474d8ba7] .p-highlight .router-link-exact-active{color:var(--primary-color)!important}[data-v-474d8ba7] .p-menuitem-link{height:103%}", ""]);
// Exports
module.exports = exports;
